import { render, staticRenderFns } from "./ParcelTransportSection.vue?vue&type=template&id=7978bf19&scoped=true&"
import script from "./ParcelTransportSection.vue?vue&type=script&lang=js&"
export * from "./ParcelTransportSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTransportSection.vue?vue&type=style&index=0&id=7978bf19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978bf19",
  null
  
)

export default component.exports